const DefaultPlanListState ={
    payload:{
        plan_id:``,
    },
    mode:``,

}

export const PlanListState = {data:DefaultPlanListState}